interface IconProps {
  fillColor: string
  backgroundColor: string
}

export const ErrorIcon = (props: IconProps) => {
  return (
    <div className="generic__icon-container generic__icon-container--error-margin">
      <svg
        width="120"
        height="120"
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="120" height="120" rx="60" fill={props.backgroundColor} />
        <path
          d="M84.8555 79.1989C85.298 78.7564 86.0157 78.7553 86.4583 79.1976C86.9008 79.64 86.9004 80.3578 86.4583 80.8005L83.763 83.4945L86.4583 86.1885C86.9007 86.6311 86.9009 87.3488 86.4583 87.7913C86.0158 88.2339 85.2981 88.2337 84.8555 87.7913L82.1615 85.096L79.4674 87.7913C79.0249 88.2335 78.3084 88.2335 77.8659 87.7913C77.4233 87.3487 77.4233 86.6311 77.8659 86.1885L80.5586 83.4945L77.8659 80.8005C77.4233 80.3579 77.4233 79.6415 77.8659 79.1989C78.3085 78.7563 79.0249 78.7563 79.4674 79.1989L82.1615 81.8916L84.8555 79.1989Z"
          fill={props.fillColor}
        />
        <path
          d="M62.6667 81.5335C63.2926 81.5335 63.7995 82.0404 63.7995 82.6663C63.7995 83.2923 63.2926 83.7992 62.6667 83.7992H45.3333C44.7074 83.7992 44.2005 83.2923 44.2005 82.6663C44.2005 82.0404 44.7074 81.5335 45.3333 81.5335H62.6667Z"
          fill={props.fillColor}
        />
        <path
          d="M54.6667 74.8669C55.2926 74.8669 55.7995 75.3738 55.7995 75.9997C55.7995 76.6256 55.2926 77.1325 54.6667 77.1325H45.3333C44.7074 77.1325 44.2005 76.6256 44.2005 75.9997C44.2005 75.3738 44.7074 74.8669 45.3333 74.8669H54.6667Z"
          fill={props.fillColor}
        />
        <path
          d="M62.6667 68.2002C63.2926 68.2002 63.7995 68.7071 63.7995 69.333C63.7995 69.9589 63.2926 70.4658 62.6667 70.4658H45.3333C44.7074 70.4658 44.2005 69.9589 44.2005 69.333C44.2005 68.7071 44.7074 68.2002 45.3333 68.2002H62.6667Z"
          fill={props.fillColor}
        />
        <path
          d="M74.6667 61.5335C75.2926 61.5335 75.7995 62.0404 75.7995 62.6663C75.7995 63.2923 75.2926 63.7992 74.6667 63.7992H45.3333C44.7074 63.7992 44.2005 63.2923 44.2005 62.6663C44.2005 62.0404 44.7074 61.5335 45.3333 61.5335H74.6667Z"
          fill={props.fillColor}
        />
        <path
          d="M74.6667 54.8669C75.2926 54.8669 75.7995 55.3738 75.7995 55.9997C75.7995 56.6256 75.2926 57.1325 74.6667 57.1325H45.3333C44.7074 57.1325 44.2005 56.6256 44.2005 55.9997C44.2005 55.3738 44.7074 54.8669 45.3333 54.8669H74.6667Z"
          fill={props.fillColor}
        />
        <path
          d="M74.6667 48.2002C75.2926 48.2002 75.7995 48.7071 75.7995 49.333C75.7995 49.9589 75.2926 50.4658 74.6667 50.4658H45.3333C44.7074 50.4658 44.2005 49.9589 44.2005 49.333C44.2005 48.7071 44.7074 48.2002 45.3333 48.2002H74.6667Z"
          fill={props.fillColor}
        />
        <path
          d="M54.6667 41.5335C55.2926 41.5335 55.7995 42.0404 55.7995 42.6663C55.7995 43.2923 55.2926 43.7992 54.6667 43.7992H45.3333C44.7074 43.7992 44.2005 43.2923 44.2005 42.6663C44.2005 42.0404 44.7074 41.5335 45.3333 41.5335H54.6667Z"
          fill={props.fillColor}
        />
        <path
          d="M70.6667 33.5335C71.2926 33.5335 71.7995 34.0404 71.7995 34.6663V41.5335H78.6667C79.2926 41.5335 79.7995 42.0404 79.7995 42.6663C79.7995 43.2923 79.2926 43.7992 78.6667 43.7992H69.5339V34.6663C69.5339 34.0404 70.0407 33.5335 70.6667 33.5335Z"
          fill={props.fillColor}
        />
        <path
          d="M62.6667 34.8669C63.2926 34.8669 63.7995 35.3738 63.7995 35.9997C63.7995 36.6256 63.2926 37.1325 62.6667 37.1325H45.3333C44.7074 37.1325 44.2005 36.6256 44.2005 35.9997C44.2005 35.3738 44.7074 34.8669 45.3333 34.8669H62.6667Z"
          fill={props.fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72.8008 28.5322L84.8008 40.5322L85.1328 40.863V71.2627C90.5044 72.6506 94.4661 77.5257 94.4661 83.333C94.4661 90.2127 88.8911 95.7992 82 95.7992C78.3804 95.7992 75.1253 94.2588 72.849 91.7992H40C37.1649 91.7992 34.8672 89.5014 34.8672 86.6663V33.333C34.8672 30.4979 37.1649 28.2002 40 28.2002H72.4701L72.8008 28.5322ZM82 73.1325C76.3614 73.1325 71.7995 77.6955 71.7995 83.333C71.7995 88.9706 76.3614 93.5335 82 93.5335C87.638 93.5335 92.2005 88.9622 92.2005 83.333C92.2005 77.6955 87.6386 73.1325 82 73.1325ZM40 30.4658C38.4168 30.4658 37.1328 31.7498 37.1328 33.333V86.6663C37.1328 88.2496 38.4168 89.5335 40 89.5335H71.1849C70.1365 87.7073 69.5339 85.5916 69.5339 83.333C69.5339 76.4438 75.1094 70.8669 82 70.8669C82.2916 70.8669 82.5806 70.8798 82.8672 70.8994V41.8018L71.5312 30.4658H40Z"
          fill={props.fillColor}
        />
      </svg>
    </div>
  )
}
